import type { CatalogPreferences, LibrarySort } from './api.ts';

export const DEFAULT_CATALOG_PREFERENCES: CatalogPreferences = {
  defaultLibrarySort: 'title',
  watchlistLayout: 'grid',
};

export const LIBRARY_SORT_OPTIONS: Array<{ value: LibrarySort; label: string }> = [
  { value: 'title', label: 'A-Z' },
  { value: 'added', label: 'Son eklenen' },
  { value: 'year', label: 'Yıl' },
  { value: 'duration', label: 'Süre' },
];

export const WATCHLIST_LAYOUT_OPTIONS: Array<{
  value: CatalogPreferences['watchlistLayout'];
  label: string;
}> = [
  { value: 'grid', label: 'Izgara' },
  { value: 'list', label: 'Liste' },
];

export function normalizeCatalogPreferences(value: unknown): CatalogPreferences {
  if (typeof value !== 'object' || value === null) return { ...DEFAULT_CATALOG_PREFERENCES };
  const input = value as Record<string, unknown>;
  const sort =
    input.defaultLibrarySort === 'added' ||
    input.defaultLibrarySort === 'year' ||
    input.defaultLibrarySort === 'duration'
      ? input.defaultLibrarySort
      : 'title';
  const layout = input.watchlistLayout === 'list' ? 'list' : 'grid';
  return { defaultLibrarySort: sort, watchlistLayout: layout };
}

export function isDefaultCatalogPreferences(value: CatalogPreferences): boolean {
  return (
    value.defaultLibrarySort === DEFAULT_CATALOG_PREFERENCES.defaultLibrarySort &&
    value.watchlistLayout === DEFAULT_CATALOG_PREFERENCES.watchlistLayout
  );
}
